import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.354 5.293L16.06 12l-6.707 6.707-1.415-1.414L13.232 12 7.94 6.707l1.415-1.414z" }));
export default createSvgIcon(iconPath, "ArrowStrokeRight");
//# sourceMappingURL=ArrowStrokeRightIcon.js.map